"use strict";

var _interopRequireDefault = require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _router = _interopRequireDefault(require("./router"));
var _store = _interopRequireDefault(require("./store"));
var _nprogress = _interopRequireDefault(require("nprogress"));
require("nprogress/nprogress.css");
var _auth = require("@/utils/auth");
var _getPageTitle = _interopRequireDefault(require("@/utils/get-page-title"));
var _settings = require("@/settings");
var _user = require("@/api/user");
// progress bar
// progress bar style
// get token from cookie

_nprogress.default.configure({
  showSpinner: false
}); // NProgress Configuration

var whiteList = ["".concat(_settings.roterPre, "/login"), '/auth-redirect']; // no redirect whitelist

_router.default.beforeEach( /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(to, from, next) {
    var hasToken;
    return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          // getMenus
          // start progress bar
          _nprogress.default.start();
          // console.log(store.getters);
          // set page title
          // document.title = getPageTitle(to.meta.title);
          document.title = (to.meta.title || '') + '-' + _store.default.getters.mer_name + '云总部';
          // determine whether the user has logged in
          hasToken = (0, _auth.getToken)();
          if (!hasToken) {
            _context.next = 7;
            break;
          }
          if (to.path === "".concat(_settings.roterPre, "/login")) {
            // if is logged in, redirect to the home page
            next({
              path: '/'
            });
            _nprogress.default.done();
          } else {
            if (from.fullPath === '/' && from.path !== "".concat(_settings.roterPre, "/login")) {
              // if (!store.getters.domain_url) {
              //   await store.dispatch('user/getDomain');
              // }

              // if (to.name === 'Dashboard') {
              //   let mList = store.getters.menuList;
              //   if (mList.length <= 0) {
              //     const m = await store.dispatch('user/getMenus');
              //     mList = m.data;
              //   }
              //   if (mList[0] && mList[0].children && mList[0].children[0] && mList[0].children[0].route !== '/merchant/dashboard') {
              //     editFormApi().then(res => {
              //       next(mList[0].children[0].route);
              //     }).catch(res => {
              //       next(mList[0].children[0].route);
              //     });
              //     return;
              //   }
              // }
              (0, _user.editFormApi)().then(function (res) {
                next();
              }).catch(function (res) {
                next();
              });
            } else {
              // if (to.name === 'Dashboard') {
              //   let mList = store.getters.menuList;
              //   if (mList.length <= 0) {
              //     const m = await store.dispatch('user/getMenus');
              //     mList = m.data;
              //   }
              //   if (mList[0] && mList[0].children && mList[0].children[0] && mList[0].children[0].route !== '/merchant/dashboard') {
              //     next(mList[0].children[0].route);
              //     return false;
              //   }
              // }
              next();
            }
          }
          _context.next = 15;
          break;
        case 7:
          if (!(whiteList.indexOf(to.path) !== -1)) {
            _context.next = 11;
            break;
          }
          // in the free login whitelist, go directly
          next();
          _context.next = 15;
          break;
        case 11:
          _context.next = 13;
          return _store.default.dispatch('user/resetToken');
        case 13:
          next("".concat(_settings.roterPre, "/login?redirect=").concat(to.path));
          _nprogress.default.done();
        case 15:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
_router.default.afterEach(function () {
  // finish progress bar
  _nprogress.default.done();
});